import * as React from 'react';
import {SVG} from "../widgets/SVG";
import {CardButton} from "./CardButton";
import {Photo} from "../Photo";

import './AllYearCard.pcss';

interface Props {
  title:string;
  subTitle?:string;
  photo:Photo;
  buttonAction:()=>void;
  openInNewTab?:boolean;
}

export const AllYearCard = (props:Props) => {

  let photo = <div></div>;
  if(props.photo) {
    if(props.photo.photoIsSVG) {
      photo = <SVG className={"svgIcon"} src={props.photo.photo} gradient title={""} aria-hidden/>;
    } else {
      photo = <div className={"imgSmall"}><img src={props.photo.smallPhoto} alt={""} aria-hidden /></div>;
    }
  }

  return(
    <div className={"allYearCard"}>
      {photo}
      <div>
        <div>
          <h3 className={'level3'}>{props.title}</h3>
          <p>{props.subTitle}</p>
        </div>
        <CardButton
          ariaButtonLabel={`Open ${props.title}${props.openInNewTab?' in a separate tab':''}`}
          buttonAction={props.buttonAction}
          buttonLabel={`Open ${props.title}`}
          hideLabel
        />
      </div>
    </div>
  );
}

